module.exports = {
      id: "video-icon-usage",
      viewBox: "0 0 92 92",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#video-icon",
      toString: function () {
        return this.url;
      }
    }